import React from 'react';
import '../../Stylesheets/Public/BubbleBackground.css';
import BubbleVector from '../../assets/illustration/Vector.svg';

const BubbleBackground = () => {
  return (
    <div className="bubble-wrapper">
      {[...Array(5)].map((_, i) => (
        <img
          key={i}
          src={BubbleVector}
          alt="bubble"
          className={`bubble bubble-${i + 1}`}
        />
      ))}
    </div>
  );
};

export default BubbleBackground;
